import React, { useState } from "react";
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import blog_1 from '../assets/img/Blogs/blog_1.jpg';
import tech_gif from '../assets/img/Blogs/Computer troubleshooting.gif';
import bg_dot_hero from '../assets/img/Illustrations/smaller_dots_bg_hero.avif'
import { useBlogContext } from './BlogContext';


function formatDateWithSuffix(date) {
    const day = new Date(date).getDate();
    const suffix = (day) => {
        if (day > 3 && day < 21) return 'th'; 
        switch (day % 10) {
            case 1: return 'st';
            case 2: return 'nd';
            case 3: return 'rd';
            default: return 'th';
        }
    };
  
    const formattedDate = new Date(date).toLocaleDateString('en-GB', {
        day: 'numeric',
        month: 'long',
        year: 'numeric'
    });
  
    return formattedDate.replace(/\d+/, (match) => `${match}${suffix(day)}`);
}

const BlogsGrid = () => {
    const { blogs, loading, error, isEmpty } = useBlogContext();
    const [currentPage, setCurrentPage] = useState(1);
    const postsPerPage = 9;
    const location = useNavigate();
    
    const sortedBlogs = blogs && blogs.length > 0 ? [...blogs].sort((a, b) => {
        return new Date(b.created_at_dt) - new Date(a.created_at_dt);
    }) : [];
    
    const indexOfLastPost = currentPage * postsPerPage;
    const indexOfFirstPost = indexOfLastPost - postsPerPage;
    const currentPosts = sortedBlogs.slice(indexOfFirstPost, indexOfLastPost);
    
    const totalPages = Math.ceil(sortedBlogs.length / postsPerPage);
    
    const paginate = (pageNumber) => {
        if (pageNumber > 0 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber);
            setTimeout(() => {
                const blogsElement = document.getElementById('blogs');
                if (blogsElement) {
                    blogsElement.scrollIntoView({ behavior: 'smooth' });
                }
            }, 100);
        }
    };
    
    const handleItemClick = (path) => {
        location(path);
    }

    const handleRefresh = () => {
        window.location.reload();
    }

    if (error && !loading) {
        return (
            <div className="portifoliobody">
                <main id="main">
                    <section id="blogs" className="about text-start" style={{paddingTop:'70px'}}>
                        <div className="blg-title">
                            <div className="blg-title-bg-img" style={{overflow:'hidden'}}><img src={bg_dot_hero} alt="" style={{ width:'inherit'}}/></div>
                            <div data-aos="fade-right" data-aos-delay="100">
                                <h1>Lab Iconics Blogs</h1>
                                <p>Your source for smart innovations in pharma, life sciences, and research.</p>
                            </div>
                        </div>
                        <div className="error-container" style={{
                            maxWidth: '800px',
                            margin: '40px auto',
                            padding: '30px',
                            backgroundColor: '#fff',
                            borderRadius: '8px',
                            boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                            textAlign: 'center'
                        }}>
                            {/* <svg className="mx-auto" width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#e53e3e" strokeWidth="2">
                                <circle cx="12" cy="12" r="10"></circle>
                                <path d="M12 7v6" stroke="#e53e3e" strokeWidth="2" strokeLinecap="round"></path>
                                <circle cx="12" cy="17" r="0.4" fill="#e53e3e"></circle>
                            </svg> */}
                            <img src={tech_gif} alt="techinal_difficulties" style={{height:'25vh'}} />
                            <h2 style={{fontSize: '24px', margin: '10px 0', color: '#333', textAlign:'center'}}>We're experiencing technical difficulties</h2>
                            <p style={{fontSize: '16px', color: '#666', marginBottom: '25px', textAlign:'center'}}>
                                We're unable to load the blog posts at this time. Our team has been notified of this issue.
                            </p>
                            <button 
                                onClick={handleRefresh}
                                style={{
                                    padding: '10px 24px',
                                    backgroundColor: '#dcdfe0',
                                    border: 'none',
                                    borderRadius: '4px',
                                    fontSize: '16px',
                                    cursor: 'pointer',
                                    fontWeight: '500'
                                }}
                            >
                                Try Again
                            </button>
                        </div>
                    </section>
                </main>
            </div>
        );
    }

    if ((isEmpty || (blogs && blogs.length === 0)) && !loading) {
        return (
            <div className="portifoliobody">
                <main id="main">
                    <section id="blogs" className="about text-start" style={{paddingTop:'70px'}}>
                        <div className="blg-title">
                            <div className="blg-title-bg-img" style={{overflow:'hidden'}}><img src={bg_dot_hero} alt="" style={{ width:'inherit'}}/></div>
                            <div data-aos="fade-right" data-aos-delay="100">
                                <h1>Lab Iconics Blogs</h1>
                                <p>Your source for smart innovations in pharma, life sciences, and research.</p>
                            </div>
                        </div>
                        <div className="empty-container" style={{
                            maxWidth: '800px',
                            margin: '40px auto',
                            padding: '30px',
                            backgroundColor: '#fff',
                            borderRadius: '8px',
                            boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                            textAlign: 'center'
                        }}>
                            <h2 style={{fontSize: '24px', margin: '20px 0', color: '#333'}}>No Blog Posts Available</h2>
                            <p style={{fontSize: '16px', color: '#666', marginBottom: '25px'}}>
                                We haven't published any blog posts yet. Please check back soon for new content on pharmaceutical innovations, research advancements, and industry insights.
                            </p>
                            <button 
                                onClick={handleRefresh}
                                style={{
                                    padding: '10px 24px',
                                    backgroundColor: '#dcdfe0',
                                    border: 'none',
                                    borderRadius: '4px',
                                    fontSize: '16px',
                                    cursor: 'pointer',
                                    fontWeight: '500'
                                }}
                            >
                                Refresh
                            </button>
                        </div>
                    </section>
                </main>
            </div>
        );
    }

    return (
        <div className='portifoliobody'>
            {loading && (
                <div id="loader" className="pageOverlay">
                    <div className="lm-preload">
                        <div className="lm-item lm-item-1"></div>
                        <div className="lm-item lm-item-2"></div>
                        <div className="lm-item lm-item-3"></div>
                        <div className="lm-item lm-item-4"></div>
                        <div className="lm-item lm-item-5"></div>
                    </div>
                </div>
            )}
            <main id="main">
                <section id="blogs" className="about text-start" style={{paddingTop:'70px'}}>
                    <div className="blg-title">
                        <div className="blg-title-bg-img" style={{overflow:'hidden'}}><img src={bg_dot_hero} alt="" style={{ width:'inherit'}}/></div>
                        <div data-aos="fade-right" data-aos-delay="100">
                            <h1>Lab Iconics Blogs</h1>
                            <p>Your source for smart innovations in pharma, life sciences, and research.</p>
                        </div>
                    </div>
                    <div className="blg-item-container">
                        <div className="blg-item-section" data-aos="fade-up" data-aos-delay="100">
                            {currentPosts.map((item, index) => {
                                const { fields } = item;
                                let path = `/blog/${item.id}`;

                                let imageSrc = null;
  
                                if (fields && fields.length > 0) {
                                    const imageField = fields.find(field => 
                                        field.content && typeof field.content === 'string' && field.content.includes('<img')
                                    );
                                    if (imageField) {
                                        const tempDiv = document.createElement('div');
                                        tempDiv.innerHTML = imageField.content;
                                        const imgElement = tempDiv.querySelector('img');
                                        if (imgElement) {
                                            imageSrc = imgElement.src;
                                        }
                                    }
                                }
                                
                                return(
                                    <div className="blg-item" key={item.id} onClick={()=>handleItemClick(path)}>
                                        <div className="blg-item-img">
                                            {imageSrc ? (
                                                <img src={imageSrc} alt={item.blog_title || ''} />
                                                ) : (
                                                <img src={blog_1} alt={item.blog_title || ''} />
                                            )}
                                        </div>
                                        <div className="blg-item-content">
                                            <div className="blg-item-title">{item.blog_title}</div>
                                            <div className="blg-item-created-by"><span>Posted on : {formatDateWithSuffix(item.created_at_dt)}</span></div>
                                            <div>{item.blog_post_content}</div>
                                            {/* <div className='learn-more-div blg-read-more'>
                                                <RouterLink to={path} href='#' style={{textDecoration:'none'}}>
                                                    <div className='blg-read-more-btn' style={{backgroundColor:'#dcdfe0'}}>
                                                        <span>Read more</span>
                                                        <div className="arrow arrow--right">
                                                            <span></span>
                                                        </div>
                                                    </div>
                                                </RouterLink>
                                            </div> */}
                                        </div>
                                    </div>
                                )
                            })} 
                        </div>
                    </div>
                    
                    {/* Pagination */}
                    {totalPages > 1 && (
                        <div className="pagination-container" style={{
                            display: 'flex',
                            justifyContent: 'center',
                            margin: '2rem 0',
                            padding: '1rem',
                            fontSize:'12px',
                        }}>
                            <div className="pagination" style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '0.5rem'
                            }}>
                                <button 
                                    onClick={() => paginate(currentPage - 1)}
                                    disabled={currentPage === 1}
                                    style={{
                                        padding: '0.5rem 1rem',
                                        border: 'none',
                                        backgroundColor: currentPage === 1 ? '#f0f0f0' : '#dcdfe0',
                                        cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
                                        borderRadius: '4px'
                                    }}
                                >
                                    &lsaquo; Previous
                                </button>
                                
                                {Array.from({ length: totalPages }, (_, i) => i + 1).map(number => {
                                    if (
                                        number === 1 || 
                                        number === totalPages || 
                                        (number >= currentPage - 2 && number <= currentPage + 2)
                                    ) {
                                        return (
                                            <button
                                                key={number}
                                                onClick={() => paginate(number)}
                                                style={{
                                                    padding: '0.5rem 1rem',
                                                    border: 'none',
                                                    backgroundColor: currentPage === number ? '#007bff' : '#dcdfe0',
                                                    color: currentPage === number ? 'white' : 'black',
                                                    cursor: 'pointer',
                                                    borderRadius: '4px'
                                                }}
                                            >
                                                {number}
                                            </button>
                                        );
                                    } else if (
                                        number === currentPage - 3 || 
                                        number === currentPage + 3
                                    ) {
                                        return <span key={number} style={{ padding: '0 0.5rem' }}>...</span>;
                                    }
                                    return null;
                                })}
                                
                                <button
                                    onClick={() => paginate(currentPage + 1)}
                                    disabled={currentPage === totalPages}
                                    style={{
                                        padding: '0.5rem 1rem',
                                        border: 'none',
                                        backgroundColor: currentPage === totalPages ? '#f0f0f0' : '#dcdfe0',
                                        cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
                                        borderRadius: '4px'
                                    }}
                                >
                                    Next &rsaquo;
                                </button>
                            </div>
                        </div>
                    )}
                </section>
            </main>
        </div>
    )
}

export default BlogsGrid;